import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../../modal/modal';



export interface AccountItem {
    id: string;
    name: string;
    cardNumber: string;
    amount: string;
    selected: boolean;
    usedAmount?: string;
    amountColor?: string;
}

@Component({
    selector: 'app-expense-selection-modal',
    standalone: true,
    imports: [CommonModule, ModalComponent],
    templateUrl: './expense-selection-modal.html',
    styleUrls: ['./expense-selection-modal.scss']
})
export class ExpenseSelectionModalComponent implements OnChanges {
    @Input() isOpen: boolean = false;
    @Input() isDropdown: boolean = false;
    @Input() title: string = 'Expense Total';
    @Input() subtitle: string = 'Select accounts to track statistics.';
    @Input() dropdownTitle: string = 'Select Accounts';
    @Input() dropdownSubtitle: string = 'Select accounts to track statistics.';
    @Input() accountsData: AccountItem[] = [];
    @Input() creditCardsData: AccountItem[] = [];
    @Output() close = new EventEmitter<void>();
    @Output() selectionChange = new EventEmitter<AccountItem[]>();

    activeTab: 'accounts' | 'cards' = 'accounts';

    accounts: AccountItem[] = [
        { id: '1', name: 'Credit Card 1', cardNumber: '5645', amount: '₹23 488.28', selected: false },
        { id: '2', name: 'Saving', cardNumber: '1234', amount: '₹23 488.28', selected: true }
    ];

    creditCards: AccountItem[] = [
        { id: 'c1', name: 'HDFC Credit', cardNumber: '5645', amount: '₹40,000.00', usedAmount: '₹10,000.00', amountColor: 'green', selected: true },
        { id: 'c2', name: 'India Bank', cardNumber: '1234', amount: '₹0.27', usedAmount: '₹40,000.00', amountColor: 'red', selected: true }
    ];

    ngOnChanges(changes: SimpleChanges): void {
        // Update accounts if accountsData input changes
        if (changes['accountsData'] && this.accountsData && this.accountsData.length > 0) {
            this.accounts = this.accountsData;
        }

        // Update credit cards if creditCardsData input changes
        if (changes['creditCardsData'] && this.creditCardsData && this.creditCardsData.length > 0) {
            this.creditCards = this.creditCardsData;
        }
    }

    onTabChange(tab: 'accounts' | 'cards') {
        this.activeTab = tab;
    }

    get isAllSelected(): boolean {
        const currentList = this.activeTab === 'accounts' ? this.accounts : this.creditCards;
        return currentList.length > 0 && currentList.every(item => item.selected);
    }

    get isPartiallySelected(): boolean {
        const currentList = this.activeTab === 'accounts' ? this.accounts : this.creditCards;
        const selectedCount = currentList.filter(item => item.selected).length;
        return selectedCount > 0 && selectedCount < currentList.length;
    }

    get totalCount(): number {
        return (this.activeTab === 'accounts' ? this.accounts : this.creditCards).length;
    }

    get selectedCount(): number {
        return (this.activeTab === 'accounts' ? this.accounts : this.creditCards).filter(item => item.selected).length;
    }

    toggleSelectAll() {
        const currentList = this.activeTab === 'accounts' ? this.accounts : this.creditCards;
        // If all selected, deselect all. Otherwise (if none or partial), select all.
        const newState = !this.isAllSelected;
        currentList.forEach(item => item.selected = newState);
    }

    get currentSubtitle(): string {
        return this.activeTab === 'cards' ? 'Select cards to track statistics.' : this.subtitle;
    }

    get currentDropdownSubtitle(): string {
        return this.activeTab === 'cards' ? 'Select cards to track statistics.' : this.dropdownSubtitle;
    }

    toggleSelection(item: AccountItem) {
        item.selected = !item.selected;
    }

    onDone() {
        const selectedAccounts = this.accounts.filter(a => a.selected);
        const selectedCards = this.creditCards.filter(c => c.selected);
        const selectedData = [...selectedAccounts, ...selectedCards];

        this.selectionChange.emit(selectedData);
        this.close.emit();
    }

    onCancel() {
        this.close.emit();
    }

    isOverLimit(item: AccountItem): boolean {
        if (!item.usedAmount) return false;
        const amount = parseFloat(item.amount.replace(/[^0-9.-]+/g, ""));
        const usedAmount = parseFloat(item.usedAmount.replace(/[^0-9.-]+/g, ""));
        return usedAmount > amount;
    }
}
